import { render, staticRenderFns } from "./onBuddyDelete.popup-chunk.vue?vue&type=template&id=602315f0&scoped=true"
import script from "./onBuddyDelete.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./onBuddyDelete.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602315f0",
  null
  
)

export default component.exports